import styled from 'styled-components';
export const Root = styled.div `
  height: 100%;
  padding: 0.28rem 0.24rem 0;
  background-color: #000537;
  color: #fff;
  .part--reservePrice, .part--tenderHighestPrice {
    font-size: 0.2rem;
    .part--price {
      line-height: 1;
      vertical-align: baseline;
      .icon {
        margin-left: 0.16rem;
        font-size: 0.2rem;
      }
      .unit {
        font-size: 0.16rem;
      }
    }
  }
  .part--reservePrice {
    padding-top: 0.24rem;
    .part--price {
      .price {
        font-size: 0.36rem;
      }
    }
  }
  .part--tenderHighestPrice {
    padding-top: 0.16rem;
    .part--price {
      .price {
        font-size: 0.28rem;
      }
    }
  }
  .tag--priceCompare {
    font-size: 0.18rem;
    color: #ffffff;
    border-radius: 4px;
    height: 0.27rem;
    line-height: 0.25rem;
    padding: 0 0.07rem;
  }
  .ant-btn.stopBtn {
    opacity: 0.37;
  }
  .ant-btn.btn--deal.stopBtn,
  .ant-btn.btn--waitDeal.stopBtn,
  .ant-btn.btn--abortive.stopBtn,
  .ant-btn.btn--askPrice.stopBtn {
    color: rgba(255, 255, 255, 0.37);
  }
  .ant-btn.btn--deal.stopBtn:hover,
  .ant-btn.btn--waitDeal.stopBtn:hover,
  .ant-btn.btn--abortive.stopBtn:hover,
  .ant-btn.btn--askPrice.stopBtn:hover {
    color: #bfbfbf;
  }
`;
export const Top = styled.div `
  padding-bottom: 0.24rem;
  border-bottom: solid 1px #666987;
  .hasBid {
    font-size: 0.2rem;
    line-height: 0.2rem;
    margin-bottom: 0.12rem;
  }
  .duration {
    font-size: 0.28rem;
    line-height: 0.28rem;
  }
  .btn_tenSecond, .btn_tenEnd, div.tenSecond, .btn_immediateEnd  {
    width: 50%;
    height: 0.6rem;
    font-size: 0.2rem;
  }
  .btn_immediateEnd {
    background-color: #ff4040;
    border-color: #ff4040;
	  border-radius: 4px;
    color: #ffffff;
  }
  .btn_tenSecond {
	  background-color: #1dbf6e;
    border-color: #1dbf6e;
	  border-radius: 4px;
    color: #ffffff;
  }
  .btn_tenEnd {
    line-height: 0.6rem;
    background-color: #f2f2f2;
    border: solid 1px #bfbfbf;
    border-radius: 4px;
    color: #bfbfbf;
    text-align: center;
  }
  div.tenSecond {
	  background-color: #fff;
    border: none;
	  border-radius: 4px;
    color: #1dbf6e;
    .ten {
      width: 36%;
      text-align: center;
    }
    .btn_ten, .btn_ten_stop {
      width: 64%;
      height: 0.6rem;
      border: none;
      border-radius: 0 4px 4px 0;
      font-size: 0.2rem;
      color: #ffffff;
    }
    .btn_ten {
      background-color: #1dbf6e;
    }
    .btn_ten_stop {
      background-color: #ff4040;
    }
  }
`;
export const Tag = styled.div `
  display: flex;
  border-radius: 4px;
  border: 1px solid;
  padding: 0 0.07rem;
`;
export const Center = styled.div `
  padding: 0.28rem 0 0.12rem 0;
  border-bottom: solid 1px #666987;
  .tag--first {
    position: absolute;
    top: -0.01rem;
    left: 0.2rem;
    margin-left: 0.24rem;
    color: #ff9900;
    font-size: 0.16rem;
    border-color: #ff9900;
    background-color: transparent;
  }
  .ant-col {
    font-size: 0.2rem;
    text-align: right;
    line-height: 0.2rem;
    margin-bottom: 0.16rem;
  }
`;
export const Footer = styled.div `
  padding-top: 0.3rem;
  flex-wrap: wrap;
  .ant-btn {
    margin-bottom: 0.12rem;
    border-radius: 4px;
    color: #fff;
    font-size: 0.2rem;
    height: 0.58rem;
  }
  .ant-btn:nth-last-child(3):first-child, .ant-btn:nth-last-child(3):first-child ~ .ant-btn,
  .ant-btn:nth-last-child(4):first-child, .ant-btn:nth-last-child(4):first-child ~ .ant-btn {
    width: 46.5%;
  }

  .btn--deal {
    background-color: #1dbf6e;
    border-color: #1dbf6e;
  }
  .btn--waitDeal {
    background-color: #4da6ff;
    border-color: #4da6ff;
  }
  .btn--abortive {
    background-color: #666666;
    border-color: #666666;
  }
  .btn--askPrice {
    background-color: #ff9900;
    border-color: #ff9900;
  }
`;
